<template>
  <div>
    <el-collapse-transition v-if="showAdvanceList">
      <div class="row advance-transactions">
        <el-table
          :data="serviceRequestTransactions"
          title="List Of Advance Transactions"
        >
          <el-table-column label="Date">
            <template slot-scope="scope">
              {{ scope.row.updatedAt | convertDate }}
            </template>
          </el-table-column>
          <el-table-column label="Amount" prop="amount" />
          <el-table-column label="Payment Mode">
            <template slot-scope="scope">
              <span v-if="scope.row.paymentMode">{{
                scope.row.paymentMode.label
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Payment Note">
            <template slot-scope="scope">
              {{ scope.row.paymentNote }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-collapse-transition>
    <el-collapse-transition v-if="showAdvanceForm">
      <div>
        <div class="add-advance">
          <div class="row">
            <div class="col-md-6">
              <base-input
                v-model="serviceRequestTransaction.amount"
                label="Amount"
              />
            </div>
            <div class="col-md-6">
              <base-input label="Payment Mode">
                <el-select v-model="serviceRequestTransaction.paymentModeId">
                  <el-option
                    v-for="(item, index) in paymentModes"
                    :key="index"
                    :value="item.paymentModeId"
                    :label="item.label"
                  />
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <base-input label="Is Advance Payment?">
                <el-radio
                  v-model="serviceRequestTransaction.isAdvance"
                  :label="true"
                  >Yes</el-radio
                >
                <el-radio
                  v-model="serviceRequestTransaction.isAdvance"
                  :label="false"
                  >No</el-radio
                >
              </base-input>
            </div>
            <div class="col-md-6">
              <base-input label="Payment Note">
                <el-input
                  v-uppercase
                  v-model="serviceRequestTransaction.paymentNote"
                  type="textarea"
                />
              </base-input>
            </div>
          </div>
        </div>
      </div>
    </el-collapse-transition>

    <div class="advance-footer">
      <el-button
        v-if="showAdvanceForm"
        type="primary"
        @click="addAdvanceTransaction()"
        >Submit</el-button
      >
      <el-button
        v-if="showAdvanceForm === true"
        type="primary"
        @click="
          showAdvanceList = true;
          showAdvanceForm = false;
        "
        >Show List</el-button
      >
      <el-button
        v-if="showAdvanceList"
        type="primary"
        @click="
          showAdvanceForm = true;
          showAdvanceList = false;
        "
        >Add Payment</el-button
      >

      <el-button type="danger" @click="closeDialog">Close</el-button>
    </div>
  </div>
</template>

<script>
import headerComponent from "../Components/HeaderComponent";
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Tag,
  Button,
  Radio
} from "element-ui";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import { format } from "date-fns";

import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  filters: {
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [CollapseTransition.name]: CollapseTransition,
    [Radio.name]: Radio,

    "header-component": headerComponent
  },
  props: {
    serviceRequestId: {
      required: true,
      type: String
    }
  },
  data: () => {
    return {
      showAdvanceForm: false,
      showAdvanceList: true
    };
  },
  computed: {
    ...mapState("serviceRequestTransaction", ["serviceRequestTransaction"]),
    ...mapGetters({
      paymentModes: "paymentMode/getPaymentModes",
      serviceRequestTransactions:
        "serviceRequestTransaction/getServiceRequestTransactions"
    })
  },
  mounted() {
    this.getPaymentModes();
    this.getServiceRequestTransactions(this.serviceRequestId);
  },
  methods: {
    ...mapActions({
      getPaymentModes: "paymentMode/getPaymentModes",
      saveServiceRequestTransaction:
        "serviceRequestTransaction/saveServiceRequestTransaction",
      updateServiceRequestTransaction:
        "serviceRequestTransaction/updateServiceRequestTransaction",
      getAdvanceAmountTransaction:
        "serviceRequestTransaction/getAdvanceAmountTransaction",
      getServiceRequestTransactions:
        "serviceRequestTransaction/getServiceRequestTransactions"
    }),
    ...mapMutations({
      resetTransaction:
        "serviceRequestTransaction/resetServiceRequestTransaction"
    }),
    addAdvanceTransaction() {
      if (this.serviceRequestTransaction.serviceRequestTransactionId) {
        this.updateServiceRequestTransaction(this.serviceRequestId).then(
          res => {
            this.$notify({
              message: "Advance Updated Succesfully!",
              type: "success",
              title: "Success"
            });
          }
        );
      } else {
        this.saveServiceRequestTransaction({
          serviceRequestId: this.serviceRequestId
        }).then(() => {
          this.$notify({
            message: "Advance Added Succesfully!",
            type: "success",
            title: "Success"
          });
          this.resetTransaction();
        });
      }
      this.getServiceRequestTransactions(this.serviceRequestId);
      this.showAdvanceForm = false;
      this.showAdvanceList = true;
    },
    closeDialog() {
      this.showAdvanceForm = false;
      this.showAdvanceList = true;
      this.$emit("close");
    }
  }
};
</script>

<style>
.advance-transactions {
  padding-top: 20px;
}
.add-advance {
  padding-top: 20px;
}
.advance-footer {
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}
</style>
